// FirstScansBanner.js — PRD-64 WP3 FollowUp Part D
//
// First-15-minute empty-state banner on the Command Center. A new user who
// finished the wizard (adding their first asset) lands on a Command Center
// of empty widgets while their first scans are running in the background.
// This banner sits above the widgets row and tells them what's happening.
// (Re-keyed off quickStartDismissedAt after the Quick Start guide was retired
// in the asset-first onboarding consolidation.)
//
// Auto-dismiss: any asset gaining `lastDiscoveryAt` flips the gate off.
// Manual dismiss: X button persists server-side via onboardingState
// (firstScansBannerDismissedAt) so dismissal survives sessions/devices.
// Implicit migration: pre-existing users with `firstAssetAt` already set get
// firstScansBannerDismissedAt synthesized from firstAssetAt — they never see
// the banner. (See api/shared/onboardingState.js implicit-completion branch.)

import React from 'react';
import './FirstScansBanner.css';

function FirstScansBanner({ assets, onboardingState, loading, onDismiss }) {
    if (loading) return null;

    const eligible = (
        Array.isArray(assets)
        && assets.length >= 1
        && assets.every(a => !a.lastDiscoveryAt)
        && (onboardingState?.completedAt || onboardingState?.dismissedAt)
        && !onboardingState?.firstScansBannerDismissedAt
    );

    if (!eligible) return null;

    return (
        <div className="first-scans-banner" role="status" aria-live="polite">
            <div className="first-scans-banner-icon" aria-hidden="true">
                <span className="first-scans-banner-clock">⏱</span>
            </div>
            <div className="first-scans-banner-body">
                <h3 className="first-scans-banner-title">Your first scans are running</h3>
                <p className="first-scans-banner-text">
                    Discovery completes in about 30 minutes. Vulnerability scan runs ~5 minutes after that, and a full deep security scan runs ~12 hours later. We'll email you when results land — feel free to close this tab.
                </p>
            </div>
            <button
                type="button"
                className="first-scans-banner-dismiss"
                onClick={onDismiss}
                aria-label="Dismiss banner"
            >
                ×
            </button>
        </div>
    );
}

export default FirstScansBanner;
